import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

import { ErrorAlert } from '../../Reusable/Alert'
import { apiGET, apiPOSTReq } from '../../../Utils/api'
import { getBPAccountsWithAccess } from '../../../Utils/util'
import environment from '../../../environment'
import { fetchBBHistory } from '../../../Utils/bankingDataManager'
import Transactions from './Transactions'
import moment from 'moment'

// Actions
import { addDataToStore, BNK_SAVE_DATA } from '../../../Actions/actions'

class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            outboundACH: true,
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <>
                <Transactions {...this.props} {...this.state} />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.bankingAppReducer,
        aionStore: state.aionAppReducer,
        userDefaults: state.userDefaultsReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Home)))